export default "__VITE_ASSET__iU6H5dx7__"